<template>
  <div>
    <b-modal v-model="modalActive" width="50%" scroll="keep">
      <div class="card">
        <header class="card-header">
          <div class="card-header-title is-flex">
            <h6 class="is-size-6 ml-auto mr-auto pl-4 has-text-weight-semibold">Error information</h6>
          </div>
          <b-button class="card-header-icon mt-2 mr-2" aria-label="more options" @click="show(false, false, false)">
            <b-icon icon="close"></b-icon>
          </b-button>
        </header>
        <div class="card-content" style="min-height: 100px">
          <div class="content" v-if="errors && errors.length > 0">
            <div v-for="(error, index) in errors" :key="index">{{index + 1}}. {{error.error}}</div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "show-errors-modal",
  components: {},
  data() {
    return {
      isLoading: false,
      modalActive: false,
      errors: []
    }
  },
  mounted() {

  },
  methods: {
    show(show, errors) {
      this.errors = errors
      this.modalActive = show
    },
  }
}
</script>

<style scoped lang="scss">
</style>